export interface CloudCategory {
  id: string;
  name: string;
  parentId: string | null;
  count: number;
  icon: string;
}

export interface CloudListing {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  summary: string;
  companyName: string;
  contactPhone: string;
  tags: string[];
  createdAt: string;
  source: string;
}

export const cloudCategories: CloudCategory[] = [
  { id: "cc-1", name: "企业服务", parentId: null, count: 1280, icon: "ri-building-line" },
  { id: "cc-1-1", name: "工商注册", parentId: "cc-1", count: 320, icon: "ri-file-text-line" },
  { id: "cc-1-2", name: "知识产权", parentId: "cc-1", count: 215, icon: "ri-shield-check-line" },
  { id: "cc-1-3", name: "ISO认证", parentId: "cc-1", count: 178, icon: "ri-award-line" },
  { id: "cc-1-4", name: "企业咨询", parentId: "cc-1", count: 567, icon: "ri-customer-service-line" },
  { id: "cc-2", name: "软件开发", parentId: null, count: 2560, icon: "ri-code-box-line" },
  { id: "cc-2-1", name: "网站开发", parentId: "cc-2", count: 890, icon: "ri-global-line" },
  { id: "cc-2-2", name: "APP开发", parentId: "cc-2", count: 760, icon: "ri-smartphone-line" },
  { id: "cc-2-3", name: "小程序开发", parentId: "cc-2", count: 540, icon: "ri-apps-line" },
  { id: "cc-2-4", name: "系统定制", parentId: "cc-2", count: 370, icon: "ri-settings-line" },
  { id: "cc-3", name: "设计策划", parentId: null, count: 1890, icon: "ri-palette-line" },
  { id: "cc-3-1", name: "品牌设计", parentId: "cc-3", count: 450, icon: "ri-brush-line" },
  { id: "cc-3-2", name: "UI/UX设计", parentId: "cc-3", count: 680, icon: "ri-layout-line" },
  { id: "cc-3-3", name: "活动策划", parentId: "cc-3", count: 390, icon: "ri-calendar-event-line" },
  { id: "cc-3-4", name: "文案策划", parentId: "cc-3", count: 370, icon: "ri-edit-line" },
  { id: "cc-4", name: "营销推广", parentId: null, count: 1670, icon: "ri-megaphone-line" },
  { id: "cc-4-1", name: "SEO优化", parentId: "cc-4", count: 420, icon: "ri-search-line" },
  { id: "cc-4-2", name: "社交媒体", parentId: "cc-4", count: 580, icon: "ri-share-line" },
  { id: "cc-4-3", name: "广告投放", parentId: "cc-4", count: 390, icon: "ri-advertisement-line" },
  { id: "cc-4-4", name: "内容营销", parentId: "cc-4", count: 280, icon: "ri-article-line" },
  { id: "cc-5", name: "财税法务", parentId: null, count: 950, icon: "ri-scales-line" },
  { id: "cc-5-1", name: "代理记账", parentId: "cc-5", count: 340, icon: "ri-book-line" },
  { id: "cc-5-2", name: "税务筹划", parentId: "cc-5", count: 210, icon: "ri-money-cny-circle-line" },
  { id: "cc-5-3", name: "法律咨询", parentId: "cc-5", count: 280, icon: "ri-government-line" },
  { id: "cc-5-4", name: "合同审核", parentId: "cc-5", count: 120, icon: "ri-file-paper-line" },
  { id: "cc-6", name: "办公商务", parentId: null, count: 1430, icon: "ri-briefcase-line" },
  { id: "cc-6-1", name: "办公租赁", parentId: "cc-6", count: 560, icon: "ri-home-office-line" },
  { id: "cc-6-2", name: "设备采购", parentId: "cc-6", count: 320, icon: "ri-computer-line" },
  { id: "cc-6-3", name: "翻译服务", parentId: "cc-6", count: 290, icon: "ri-global-line" },
  { id: "cc-6-4", name: "商务接待", parentId: "cc-6", count: 260, icon: "ri-hotel-line" },
  { id: "cc-7", name: "教育培训", parentId: null, count: 2100, icon: "ri-graduation-cap-line" },
  { id: "cc-7-1", name: "职业技能", parentId: "cc-7", count: 780, icon: "ri-tools-line" },
  { id: "cc-7-2", name: "语言培训", parentId: "cc-7", count: 450, icon: "ri-speak-line" },
  { id: "cc-7-3", name: "学历教育", parentId: "cc-7", count: 390, icon: "ri-school-line" },
  { id: "cc-7-4", name: "企业培训", parentId: "cc-7", count: 480, icon: "ri-team-line" },
  { id: "cc-8", name: "生活服务", parentId: null, count: 3200, icon: "ri-service-line" },
  { id: "cc-8-1", name: "家政保洁", parentId: "cc-8", count: 890, icon: "ri-home-smile-line" },
  { id: "cc-8-2", name: "搬家物流", parentId: "cc-8", count: 560, icon: "ri-truck-line" },
  { id: "cc-8-3", name: "维修安装", parentId: "cc-8", count: 720, icon: "ri-hammer-line" },
  { id: "cc-8-4", name: "美容美发", parentId: "cc-8", count: 1030, icon: "ri-scissors-line" },
  { id: "cc-9", name: "餐饮食品", parentId: null, count: 1560, icon: "ri-restaurant-line" },
  { id: "cc-9-1", name: "餐厅加盟", parentId: "cc-9", count: 430, icon: "ri-store-line" },
  { id: "cc-9-2", name: "食材供应", parentId: "cc-9", count: 380, icon: "ri-leaf-line" },
  { id: "cc-9-3", name: "烘焙甜点", parentId: "cc-9", count: 290, icon: "ri-cake-line" },
  { id: "cc-9-4", name: "饮品茶饮", parentId: "cc-9", count: 460, icon: "ri-cup-line" },
  { id: "cc-10", name: "医疗健康", parentId: null, count: 980, icon: "ri-heart-pulse-line" },
  { id: "cc-10-1", name: "医疗器械", parentId: "cc-10", count: 230, icon: "ri-first-aid-kit-line" },
  { id: "cc-10-2", name: "健康管理", parentId: "cc-10", count: 310, icon: "ri-mental-health-line" },
  { id: "cc-10-3", name: "美容整形", parentId: "cc-10", count: 280, icon: "ri-user-smile-line" },
  { id: "cc-10-4", name: "养生保健", parentId: "cc-10", count: 160, icon: "ri-plant-line" },
];

const titleTemplates = [
  "专业{service}服务，{feature}，{benefit}",
  "{company}提供{service}，{feature}，价格实惠",
  "高品质{service}，{feature}，{benefit}",
  "{service}专家团队，{feature}，{benefit}",
  "一站式{service}解决方案，{feature}",
];

const services: Record<string, string[]> = {
  "cc-1-1": ["工商注册", "公司注册", "营业执照办理"],
  "cc-1-2": ["商标注册", "专利申请", "版权登记"],
  "cc-1-3": ["ISO9001认证", "ISO14001认证", "质量体系认证"],
  "cc-1-4": ["管理咨询", "战略规划", "企业诊断"],
  "cc-2-1": ["企业官网开发", "电商网站建设", "响应式网站设计"],
  "cc-2-2": ["iOS/Android开发", "跨平台APP开发", "原生APP定制"],
  "cc-2-3": ["微信小程序开发", "支付宝小程序", "抖音小程序"],
  "cc-2-4": ["ERP系统定制", "OA系统开发", "CRM系统定制"],
  "cc-3-1": ["品牌VI设计", "Logo设计", "品牌形象策划"],
  "cc-3-2": ["UI界面设计", "UX交互设计", "产品原型设计"],
  "cc-3-3": ["年会策划", "发布会策划", "展会策划"],
  "cc-3-4": ["品牌文案", "营销文案", "产品描述撰写"],
  "cc-4-1": ["SEO整站优化", "关键词排名提升", "网站流量增长"],
  "cc-4-2": ["抖音代运营", "小红书推广", "微信公众号运营"],
  "cc-4-3": ["百度竞价推广", "信息流广告", "朋友圈广告投放"],
  "cc-4-4": ["内容营销策划", "软文推广", "KOL合作"],
  "cc-5-1": ["代理记账报税", "财务外包服务", "月度账务处理"],
  "cc-5-2": ["企业税务筹划", "个税优化", "税务风险管控"],
  "cc-5-3": ["企业法律顾问", "合同纠纷处理", "劳动争议咨询"],
  "cc-5-4": ["合同起草审查", "协议审核修改", "法律文书撰写"],
  "cc-6-1": ["共享办公空间", "联合办公出租", "写字楼租赁"],
  "cc-6-2": ["办公设备采购", "电脑耗材供应", "打印机租赁"],
  "cc-6-3": ["商务翻译服务", "同声传译", "文件翻译"],
  "cc-6-4": ["商务接待服务", "会议室租赁", "商务用车"],
  "cc-7-1": ["职业技能培训", "技能认证考试", "岗位技能提升"],
  "cc-7-2": ["英语培训", "日语培训", "商务外语课程"],
  "cc-7-3": ["成人学历提升", "在职研究生", "自考辅导"],
  "cc-7-4": ["企业内训", "管理培训", "团队建设培训"],
  "cc-8-1": ["家政保洁服务", "深度清洁", "日常保洁"],
  "cc-8-2": ["搬家服务", "长途搬运", "货物配送"],
  "cc-8-3": ["家电维修", "水电安装", "空调清洗"],
  "cc-8-4": ["美发造型", "美甲美睫", "皮肤护理"],
  "cc-9-1": ["餐饮加盟", "品牌连锁加盟", "特色餐厅加盟"],
  "cc-9-2": ["新鲜食材配送", "有机蔬菜供应", "肉类批发"],
  "cc-9-3": ["烘焙培训", "蛋糕定制", "西点制作"],
  "cc-9-4": ["奶茶加盟", "咖啡品牌", "果汁饮品"],
  "cc-10-1": ["医疗器械销售", "康复设备租赁", "医疗耗材供应"],
  "cc-10-2": ["健康体检", "慢病管理", "营养咨询"],
  "cc-10-3": ["医美整形", "皮肤美容", "微整形服务"],
  "cc-10-4": ["中医养生", "保健按摩", "营养保健品"],
};

const companies = [
  "星辰科技", "云帆网络", "鑫达商务", "恒远咨询", "博远信息",
  "创智科技", "汇通服务", "明远企业", "盛达集团", "华远科技",
  "新锐创意", "卓越服务", "精英团队", "专业机构", "优质服务商",
  "领先科技", "创新工作室", "专业团队", "行业专家", "资深机构",
];

const features = [
  "经验丰富", "专业团队", "快速响应", "价格透明", "品质保障",
  "一对一服务", "7×24小时", "全程跟进", "效果保证", "口碑良好",
];

const benefits = [
  "助力业务增长", "提升品牌形象", "降低运营成本", "提高工作效率",
  "解决后顾之忧", "让您省心省力", "专注核心业务", "快速见效",
];

function generateCloudListings(): CloudListing[] {
  const result: CloudListing[] = [];
  const subCats = cloudCategories.filter((c) => c.parentId !== null);

  subCats.forEach((cat) => {
    const serviceList = services[cat.id] || [cat.name + "服务"];
    const count = Math.min(cat.count, 50);
    for (let i = 0; i < count; i++) {
      const service = serviceList[i % serviceList.length];
      const company = companies[Math.floor(Math.random() * companies.length)];
      const feature = features[Math.floor(Math.random() * features.length)];
      const benefit = benefits[Math.floor(Math.random() * benefits.length)];
      const titleTemplate = titleTemplates[i % titleTemplates.length];
      const title = titleTemplate
        .replace("{service}", service)
        .replace("{feature}", feature)
        .replace("{benefit}", benefit)
        .replace("{company}", company);

      const parent = cloudCategories.find((c) => c.id === cat.parentId);
      result.push({
        id: `cloud-${cat.id}-${i + 1}`,
        title,
        categoryId: cat.id,
        categoryName: cat.name,
        summary: `提供专业${service}，${feature}，${benefit}。服务覆盖全国，支持线上线下对接，欢迎咨询合作。`,
        companyName: `${company}有限公司`,
        contactPhone: `1${Math.floor(Math.random() * 9) + 3}${Math.floor(Math.random() * 9000000000 + 1000000000)}`,
        tags: [cat.name, parent?.name || "", feature].filter(Boolean),
        createdAt: new Date(Date.now() - Math.random() * 90 * 24 * 3600 * 1000).toISOString(),
        source: "云端数据库",
      });
    }
  });

  return result;
}

export const cloudListings: CloudListing[] = generateCloudListings();
